import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'ps-variable-mapping',
  templateUrl: './variable-mapping.component.html',
  styleUrls: ['../base-form.css'],
})
export class VariableMappingComponent {
  @Input()
  form!: UntypedFormGroup;
  constructor() {}
}
